import React, { useState, useEffect } from "react";
import "../styles/BulkGeneration.css";
import "../styles/BulkQrs.css";
import { toast, ToastContainer } from "react-toastify";
import BusinessHubHeader from "../components/BusinessHubHeader.js";
import BackArrow from "../icons/BusinessHub/BackArrow.js";
import { useNavigate } from "react-router-dom";
import ViewIcon from "../icons/BusinessHub/ViewIcon.js";
import ClockIcon from "../icons/BusinessHub/ClockIcon.js";
import PuaseIcon from "../icons/BusinessHub/PuaseIcon.js";
import CompleteTick from "../icons/BusinessHub/CompleteTick.js";
import RetryIcon from "../icons/BusinessHub/RetryIcon.js";
import ExplanationTriangleIcon from "../icons/BusinessHub/ExplanationTriangleIcon.js";
import PlayIcon from "../icons/BusinessHub/PlayIcon.js";
import ExplanationIcon from "../icons/BusinessHub/ExplanationIcon.js";
import InfoPerson from "../icons/BusinessHub/InfoPerson.js";
import CustomDropdown from "./StatusDropdown";
import ArrowDownIcon from "../icons/BusinessHub/ArrowDownIcon.js";
import { userService } from "../services/userService.js";
import companyController from "../controllers/companyController.js";
import { EncryptStorage } from "encrypt-storage";
import Utils from "../utils/Utils";

function BulkGeneration() {
  const encryptStorage7 = new EncryptStorage("secret-key7", {
    prefix: "@instance7",
  });
  const [qrstatus, setqrstatus] = useState([]);
  const [Paused, setPaused] = useState(false);
  const Compname = userService.getCompName();
  const compInitials = userService.getCompName()?.slice(0, 2).toUpperCase();
  const [codePref, setcodePref] = useState("");
  const [start, setstart] = useState(false);
  const navigate = useNavigate();
  const [done, setdone] = useState(false);

  useEffect(() => {
    const p = qrstatus?.progress ?? 0;
    setdone(p === 1);
  }, [qrstatus?.progress]);

  /***************************************** */
  const minQuantity = 1;
  const maxQuantity = 10000;
  const [quantity, setQuantity] = useState(0);
  const [EstimatedTime, setEstimatedTime] = useState(0);
  useEffect(() => {
    const maxTime = 20;
    const minTime = 1;

    const q = Math.max(minQuantity, Math.min(quantity, maxQuantity));
    const time = (q / maxQuantity) * maxTime;

    setEstimatedTime(Math.max(minTime, Math.round(time)));
  }, [quantity]);
  const [status, setStatus] = useState("");
  const [Validity, setValidity] = useState(48);
  const [commercialSectionIds, setCommercialSectionIds] = useState([1]);

  const addCommercialSection = () => {
    setCommercialSectionIds((prev) => [...prev, Date.now() + prev.length]);
  };

  const removeCommercialSection = (id) => {
    setCommercialSectionIds((prev) =>
      prev.length > 1 ? prev.filter((skuId) => skuId !== id) : prev,
    );
  };

  const quantityProgress =
    ((quantity - minQuantity) / (maxQuantity - minQuantity)) * 100;

  const [qrBulkJobs, setQrBulkJobs] = useState();
  const handleStartGeneration = async () => {
    const req = {
      companyId: userService.getCompID(),
      count: quantity,
      initials: compInitials,
      validityHours: Validity,
    };
    try {
      const QrBulkJobs = await companyController.QrBulkJobs({
        req: req,
        Authorization: userService.getUser(),
      });
      if (QrBulkJobs && QrBulkJobs.status === 200) {
        encryptStorage7.setItem("QR-job", QrBulkJobs.data.jobId);
        setstart(true);
        window.location.reload();
        setQrBulkJobs(QrBulkJobs.data);
      }
    } catch (error) {}
  };
  /************************************************************* */
  useEffect(() => {
    if (!userService.getQrJodID()) return;
    setstart(true);
    const getQrStatus = async () => {
      const res = await companyController.QrBulkJobsStatus({
        Authorization: userService.getUser(),
        jobId: userService.getQrJodID(),
        skipGlobalLoader: true,
      });
      const data = res?.data;
      setqrstatus(data);
      if (data?.status === "PAUSED") setPaused(true);
      if (data?.progress === 1) {
        encryptStorage7.removeItem("QR-job");
        clearInterval(interval);
      }
    };
    getQrStatus();
    const interval = setInterval(getQrStatus, 3000);
    return () => clearInterval(interval);
  }, []);
  /************************************************************* */
  const handlePause = async () => {
    const QrBulkpause = await companyController.QrBulkpause({
      jobId: userService.getQrJodID(),
      Authorization: userService.getUser(),
    });
    if (QrBulkpause) {
      setPaused(true);
    }
  };

  const handleResume = async () => {
    const QrBulkpause = await companyController.QrBulkResume({
      jobId: userService.getQrJodID(),
      Authorization: userService.getUser(),
    });
    if (QrBulkpause) {
      setPaused(false);
    }
  };
  const formatDateTime = (dateString) => {
    const d = new Date(dateString);

    const date = d.toLocaleDateString("en-GB"); // 05/03/2026
    const time = d.toLocaleTimeString("en-US", {
      hour: "numeric",
      minute: "2-digit",
      hour12: true,
    });

    return `${date} - ${time}`;
  };
  const addMinutes = (dateString, minutes) => {
    if (!dateString) return "";

    const d = new Date(dateString);
    d.setMinutes(d.getMinutes() + minutes);

    const date = d.toLocaleDateString("en-GB");
    const time = d.toLocaleTimeString("en-US", {
      hour: "numeric",
      minute: "2-digit",
      hour12: true,
    });

    return `${date} - ${time}`;
  };

  const handleCancel = async () => {
    const cancelGneration = await companyController.QrBulkCancel({
      jobId: userService.getQrJodID(),
      Authorization: userService.getUser(),
    });
    if (cancelGneration.status === 200) {
      encryptStorage7.removeItem("QR-job");
      navigate("/Qr-code-management");
    }
  };
  const handleRetry = async () => {
    const RetryFailed = await companyController.QrBulkRetyFailed({
      Authorization: userService.getUser(),
      jobId: userService.getQrJodID(),
    });
    if (Utils.isSuccessResponse(RetryFailed)) {
      toast.success("Retrieng");
    }
  };
  return (
    <div>
      <div className="create-qr-page-header">
        <BusinessHubHeader />
      </div>

      <div className="create-qr-content-main-container">
        <div className="create-qr-content-container">
          <div className="create-qr-data-header">
            <div className="create-qr-header-navigation">
              <div
                className="create-qr-header-navigation-icon"
                onClick={() => navigate("/Qr-code-management")}
              >
                <BackArrow />
              </div>
              <div className="create-qr-header-navigation-text">
                QR Code Management
              </div>
            </div>

            <div className="create-qr-header-text">
              <div className="create-qr-header-title">Bulk QRs Generation</div>
            </div>
          </div>

          {start ? (
            <div className="create-qr-body">
              <div className="create-qr-body-basic-info">
                <div className="create-bulkqr-basic-info-body">
                  <div className="generate-bulkqr-body">
                    <div className="bulkqr-generate-head-title">
                      <div className="bulkqr-create-title">
                        <div className="bulkqr-create-title-text">
                          Generation Progress
                        </div>
                        <div className="bulkqr-create-title-note">
                          Real-time status of your bulk QR code generation.
                        </div>
                      </div>
                      {done ? (
                        <div className="bulkqr-generating-state-comp">
                          <CompleteTick />
                          Completed
                        </div>
                      ) : (
                        <div>
                          {Paused ? (
                            <div className="bulkqr-generating-state">
                              <ClockIcon />
                              Paused
                            </div>
                          ) : (
                            <div className="bulkqr-generating-state">
                              <ClockIcon />
                              In Progress
                            </div>
                          )}
                        </div>
                      )}
                    </div>
                    <div className="bulkqr-generation-overall">
                      <div className="bulkqr-generation-overall-header">
                        <div className="bulkqr-generation-overall-label">
                          Overall Progress
                        </div>
                        <div className="bulkqr-generation-overall-value">
                          {Math.round((qrstatus?.progress ?? 0) * 100)}%
                        </div>
                      </div>
                      <div className="bulkqr-generation-overall-progress-bar">
                        <div
                          className="bulkqr-generation-overall-progress-fill"
                          style={{
                            width: `${Math.round((qrstatus?.progress ?? 0) * 100)}%`,
                          }}
                        ></div>
                      </div>
                    </div>

                    <div className="bulkqr-generation-overall-table">
                      <div className="bulkqr-generation-overall-cont">
                        <div className="bulkqr-generation-overall-body">
                          <div className="bulkqr-generation-overall-title">
                            Total QR Codes
                          </div>
                          <div className="bulkqr-generation-overall-number">
                            {qrstatus?.total}
                          </div>
                        </div>
                      </div>
                      <div className="bulkqr-generation-overall-container">
                        <div className="bulkqr-generation-overall-body">
                          <div className="bulkqr-generation-overall-title">
                            Generated
                          </div>
                          <div className="bulkqr-generation-overall-number-succ">
                            {qrstatus?.generated}
                          </div>
                        </div>
                      </div>
                      <div className="bulkqr-generation-overall-container">
                        <div className="bulkqr-generation-overall-body">
                          <div className="bulkqr-generation-overall-title">
                            Failed
                          </div>
                          <div className="bulkqr-generation-overall-number-failed">
                            {qrstatus?.failed}
                          </div>
                        </div>
                      </div>
                      <div className="bulkqr-generation-overall-container">
                        <div className="bulkqr-generation-overall-body">
                          <div className="bulkqr-generation-overall-title">
                            Pending
                          </div>
                          <div className="bulkqr-generation-overall-number-pending">
                            {qrstatus?.pending}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="bulkqr-generation-overall-date">
                      <div className="bulkqr-generation-date">
                        <div className="bulkqr-generation-date-text">
                          Started
                        </div>
                        <div className="bulkqr-generation-date-date">
                          {formatDateTime(qrstatus?.startedAt)}
                        </div>
                      </div>
                      {/* <div className="bulkqr-generation-date">
                        <div className="bulkqr-generation-date-text">
                          Estimated Completion
                        </div>
                        <div className="bulkqr-generation-date-date">
                          {qrstatus?.finishedAt
                            ? formatDateTime(qrstatus?.finishedAt)
                            : null}
                        </div>
                      </div> */}
                      {qrstatus?.status === "COMPLETED" ? (
                        <div className="bulkqr-generation-date">
                          <div className="bulkqr-generation-date-text">
                            Finished At
                          </div>
                          <div className="bulkqr-generation-date-date">
                            {formatDateTime(qrstatus?.finishedAt)}
                          </div>
                        </div>
                      ) : (
                        <div className="bulkqr-generation-date">
                          <div className="bulkqr-generation-date-text">
                            Estimated Completion
                          </div>
                          <div className="bulkqr-generation-date-date">
                            {addMinutes(qrstatus?.startedAt, EstimatedTime)}
                          </div>
                        </div>
                      )}
                    </div>
                    {qrstatus?.data?.failed > 0 && (
                      <div className="bulk-generation-errors">
                        <div className="bulk-generation-errors-cont">
                          <div className="bulk-generation-errors-text">
                            <div className="bulk-generation-errors-title">
                              <ExplanationTriangleIcon /> Generation Errors (
                              {qrstatus.data.failed})
                            </div>

                            <div className="bulk-generation-errors-disc">
                              {qrstatus.data.failed} QR codes failed to
                              generate.
                            </div>
                          </div>

                          <div
                            className="bulk-generation-errors-action"
                            onClick={() => handleRetry()}
                          >
                            <RetryIcon />
                            Retry
                          </div>
                        </div>
                      </div>
                    )}
                    <div className="create-qr-action-button">
                      {done ? (
                        <div
                          className="create-bulkqr-action-created"
                          onClick={() => {
                            encryptStorage7.removeItem("QR-job");
                            navigate("/Qr-code-management");
                          }}
                        >
                          <ViewIcon fill="#ffff" /> View Generated QRs
                        </div>
                      ) : (
                        <div>
                          {Paused ? (
                            <div
                              className="create-bulkqr-action-puase"
                              onClick={() => handleResume()}
                            >
                              <PuaseIcon /> Resume Generation
                            </div>
                          ) : (
                            <div
                              className="create-bulkqr-action-puase"
                              onClick={() => handlePause()}
                            >
                              <PuaseIcon /> Pause Generation
                            </div>
                          )}
                        </div>
                      )}
                      {done ? (
                        <div
                          className="create-qr-action-done-back"
                          onClick={() => {
                            encryptStorage7.removeItem("QR-job");
                            navigate("/Qr-code-management");
                          }}
                        >
                          Back QR Management
                        </div>
                      ) : (
                        <div
                          className="create-qr-action-cancel"
                          onClick={() => {
                            handleCancel();
                          }}
                        >
                          Cancel
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ) : (
            <div className="create-qr-body">
              <div className="create-qr-body-basic-info">
                <div className="create-bulkqr-basic-info-body">
                  <div className="create-bulkqr-body">
                    <div className="bulkqr-create-title">
                      <div className="bulkqr-create-title-text">
                        QR Code Settings
                      </div>
                      <div className="bulkqr-create-title-note">
                        Configure parameters for QR code generation.
                      </div>
                    </div>
                    <div className="bulkqr-code-prefix-cont">
                      <div className="bulkqr-code-prefix">QR Code Prefix</div>
                      <div className="bulkqr-code-prefix">
                        <input
                          disabled
                          className="qr-prifix-input"
                          placeholder={compInitials}
                          onChange={(e) => setcodePref(e.target.value)}
                        />
                      </div>
                      <div className="bulkqr-code-prefix-note">
                        Prefix will be added based on the first 2 letters of
                        each organization (e.g., AZ-001, AZ-002).
                      </div>
                    </div>
                    <div className="bulkqr-create-quantity-selector">
                      <div className="bulkqr-creation-quantity-selector">
                        <div className="bulkqr-quantity-label">
                          Quantity <span className="required">*</span>
                        </div>
                        <div className="bulkqr-generation-code-number">
                          {quantity} Codes
                        </div>
                      </div>
                      <input
                        type="range"
                        min={minQuantity}
                        max={maxQuantity}
                        value={quantity}
                        className="bulkqr-quantity-slider"
                        onChange={(e) => setQuantity(Number(e.target.value))}
                        style={{
                          "--quantity-progress": `${quantityProgress}%`,
                        }}
                      />
                      <input
                        className="yehyatrad-bado-yeha"
                        type="number"
                        inputMode="numeric"
                        min="0"
                        max="10000"
                        step="1"
                        value={quantity}
                        onChange={(e) => {
                          const value = Math.min(
                            10000,
                            Math.max(0, Number(e.target.value)),
                          );
                          setQuantity(value);
                        }}
                      />
                      <div className="bulkqr-create-title-note-bulkqr-quantity-note">
                        QR code generate between 1 and 10,000 QR codes at once.
                      </div>
                    </div>{" "}
                    <div className="bulkqr-code-prefix-cont">
                      <div className="bulkqr-code-prefix">
                        Validity Period <span className="required">*</span>
                      </div>
                      <div className="bulkqr-code-prefix">
                        <CustomDropdown
                          rightIcon={<ArrowDownIcon />}
                          value={Validity}
                          onChange={setValidity}
                          placeholder="48 Hours"
                          options={[
                            { label: "48 hours", value: "48" },
                            { label: "36 hours", value: "36" },
                            { label: "24 hours", value: "24" },
                            { label: "18 hours", value: "18" },
                            { label: "12 hours", value: "12" },
                            { label: "6 hours", value: "6" },
                          ]}
                          className="filter-popup-container-rows-input-container-units"
                          menuClassName="status-drop-menu-container"
                          optionClassName="status-drop-menu-option"
                        />
                      </div>
                      <div className="bulkqr-code-prefix-note">
                        QR code will be marked as expired after this period.
                      </div>
                    </div>
                    <div className="bulk-generation-summery">
                      <div className="bulk-generation-summery-cont">
                        <div className="bulk-generation-summery-header">
                          <ExplanationIcon />
                          Generation Summary
                        </div>
                        <div className="bulk-generation-summery-body">
                          <div className="bulk-generation-body-content">
                            <div className="bulk-generate-summery-entries">
                              Total QR Codes:
                            </div>
                            <div className="bulk-generate-summery-entry">
                              {quantity}
                            </div>
                          </div>
                          <div className="bulk-generation-body-content">
                            <div className="bulk-generate-summery-entries">
                              Prefix:
                            </div>
                            <div className="bulk-generate-summery-entry">
                              {compInitials}
                            </div>
                          </div>
                          <div className="bulk-generation-body-content">
                            <div className="bulk-generate-summery-entries">
                              Expiry:
                            </div>
                            <div className="bulk-generate-summery-entry">
                              {Validity} Hours
                            </div>
                          </div>
                        </div>
                        <div className="bulk-generation-summery-footer">
                          <div className="bulk-generate-summery-entries">
                            Estimated Time:
                          </div>
                          <div className="bulk-generate-summery-entry">
                            {EstimatedTime} min
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="bulkqr-create-footer">
                      <div className="bulkqr-create-title-text">
                        <InfoPerson />
                      </div>
                      <div className="bulkqr-create-title-note">
                        Bulk QR generation may take a few minutes depending on
                        the quantity. You'll be able to track the progress on
                        the next page.
                      </div>
                    </div>
                    <div className="create-qr-action-button">
                      <div
                        className="create-bulkqr-action-create"
                        onClick={() => handleStartGeneration()}
                      >
                        <PlayIcon /> Start Generation
                      </div>
                      <div
                        className="create-qr-action-cancel"
                        onClick={() => {
                          navigate("/Qr-code-management");
                        }}
                      >
                        Cancel
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}
          <div className="create-qr-action-button"></div>
        </div>
      </div>
    </div>
  );
}

export default BulkGeneration;
